import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';

import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'putawayPending-report',
	components: {
		//Paginate,
		BasicSelect,
		DatePicker,
		Loader,
		JsonExcel,
		Pagination
	},
	props: [],
	data() {
		","
		return {
			selectedmerchant: { value: '', text: '' },
			merchantList: [],
			merchantId: '',
			listMerchantIdData: [],
			merchantnameFlt: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalRows: 0,
			currentPage: 1,
			totalPage: 0,
			pageLimit: 10,
			isLoadingforxls: false,
			// currentPage: 0,
			listRackinData: [],
			tableArr: [],
			SKUArr: [],
			fdata: [],
			// perPage: 10,
			// pageno: 0,
			// pageCount: 0,
			fromdate: '',
			todate: '',
			POID: '',
			DRID: '',
			InvoiceNumber: '',
			InvoiceNumber: '',
			ProductID: '',
			showTable: false,
			listReportDatacsv: [],
			csvFields: [],
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			searchFlag: false,
			client: '',
			warehouse: '',
			warehouseid: '',
			clientid: '',
			user_type: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			mid: ''
		}
	},
	computed: {},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY');
		}
	},
	mounted() {
		this.calldateFunction();
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.user_type = userdetail.utype;
		this.reportname = this.$t('editedjson.putAwayPendingReport');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
	        this.getMerchantList();
         }

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectMerchant = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectMerchant = true;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchantnameFlt = data.value;
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getRackinReportDataForXls(3)
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		this.totalRows = 0;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.getMerchantList();
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}

		// 			// this.getRackinReportData();
		// 		}
		// 	}
		// 	this.listRackinData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getRackinReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.listMerchantData = result.data;
					this.merchantList.push({
						value: '', text: this.$t('common.selectMerchantPlaceHolder')
					}
					)
					for (var i = 0; i < this.listMerchantData.length; i++) {
						// console.log( this.listMerchantData.merchantname[i],"merchname")
						this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						});
					}
				}, error => {
					console.error(error);
				})
		},
		scrollWin() {
			window.scrollTo(0, 500);
		},
		getRackinReportDataSearch() {
			this.currentPage = 1;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getRackinReportData(2);
		},
		//to get Stock Report list
		getRackinReportData(csvCheck = 0) {
			this.showTable = false;

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.pageCount = 0;
				this.listRackinData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.pageCount = 0;
				this.listRackinData = [];
				return false;
			}

			this.isLoading = true;
			var fr_date = '';
			var to_date = '';
			if (this.fromdate) {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat(this.todate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromddate: this.dateFormat1(fr_date),
				todate: this.dateFormat2(to_date),
				pono: this.POID,
				productid: this.ProductID.trim(),
				invreferenceid: this.DRID.trim(),
				csvData: csvCheck,
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invoiceno: this.InvoiceNumber.trim(),
				merchantid: this.merchantnameFlt,


			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'rackinReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.listReportDatacsv = [];
						this.csvFields = {
							'invreferenceid': this.$t('removeHold.drId'),
							'pono': this.$t('removeHold.poId'),
							'grndatetime': this.$t('editedjson.grndate'),
							'invoiceno': this.$t('packingb2b.b2bPacking.modal.invoiceNumber'),
							'sku': this.$t('removeHold.putAwayPendingSKU'),
							'pending':  this.$t('removeHold.putAwayPendingQty'),
							'merchantname': this.$t('warehouseRacks.merchant'),

						};
						var dateFilter = [];
						var skipFilter = ['count'];
						this.listReportDatacsv = [];
						this.listReportDatacsv = result.data.data
						console.log(this.listReportDatacsv, 'this.listReportDatacsv');

						csvHelper.data.jsonToCSV(this.$t('editedjson.putAwayPendingReport'), this.listReportDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('PutAwayPendingReport', this.listReportDatacsv, this.csvFields, dateFilter, skipFilter);
					} else {
						this.listRackinData = result.data.data

						if (result.data.errorCode == -1) {
							this.resultCount = 0
							this.totalRows = 0;
						} else {

							this.totalRows = Number(result.data.count);
							this.resultCount = result.data.count;
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		getRackinReportDataForXls(csvCheck = 0) {
			this.showTable = false;

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error('Please Select Client')
				this.pageNo = this.pageCount = 0;
				this.listRackinData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error('Please Select Warehouse')
				this.pageNo = this.pageCount = 0;
				this.listRackinData = [];
				return false;
			}


			var fr_date = '';
			var to_date = '';
			if (this.fromdate) {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat(this.todate)
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromddate: this.dateFormat1(fr_date),
				todate: this.dateFormat2(to_date),
				pono: this.POID,
				productid: this.ProductID.trim(),
				invreferenceid: this.DRID.trim(),
				csvData: csvCheck,
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				invoiceno: this.InvoiceNumber.trim(),
				merchantid: this.merchantnameFlt,


			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'rackinReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('removeHold.drId')] = 'invreferenceid',
							this.csvFieldsForXls[this.$t('removeHold.poId')] = 'pono',
							this.csvFieldsForXls[this.$t('editedjson.grndate')] =  'grndatetime',
							this.csvFieldsForXls[this.$t('warehouseRacks.merchant')] = 'merchantname',
							this.csvFieldsForXls[this.$t('packingb2b.b2bPacking.modal.invoiceNumber')] = 'invoiceno',
							this.csvFieldsForXls[this.$t('removeHold.putAwayPendingSKU')] = 'sku',
							this.csvFieldsForXls[this.$t('removeHold.putAwayPendingQty')] =  'pending'

							this.listReportDataforxls = result.data.data

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error)
				})
		},
		//  show table
		showTableData(invreferenceid, pono, grndate) {
			if (pono == null) {
				pono = "";
			}
			if (invreferenceid != '' && invreferenceid != null) {
				this.selected = true;
				this.invreferenceid = invreferenceid;
				this.pono = pono;
				this.grndate = grndate;
			}
			this.showTable = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			let newdate = grndate.split(" ");
			newdate = newdate[0].split("/").reverse().join("-");
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				pono: pono,
				invreferenceid: invreferenceid,
				productid: this.ProductID,
				grndate: newdate
			})
			if (this.client != '') {
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'SKUList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				}).then(result => {
					var Arrdata = result.data.data
					this.SKUArr = [];
					for (var x = 0; x < Arrdata.length; x++) {
						var total = 0;
						total = parseInt(Arrdata[x].acceptpendingqty) + parseInt(Arrdata[x].rejectpendingqty) + parseInt(Arrdata[x].notinpopendingqty);
						this.SKUArr.push({
							"productid": Arrdata[x].productid,
							"mrp": Arrdata[x].mrp,
							"acceptpendingqty": Arrdata[x].acceptpendingqty,
							"eancode": Arrdata[x].eancode,
							"rejectpendingqty": Arrdata[x].rejectpendingqty,
							"notinpopendingqty": Arrdata[x].notinpopendingqty,
							"total": total,
						})
					}
				}, error => {
					console.error(error)
				})
			} else {
				this.ClientErr = this.$t('srReport.clientError');
			}


		},


		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage
		// 	this.getRackinReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getRackinReportData()
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		dateFormatFRTTbl(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.fromdate = '';
			this.todate = '';
			this.POID = '';
			this.DRID = '';
			this.totalRows = 0;
			this.InvoiceNumber = '';
			this.ProductID = '';
			this.merchantnameFlt = '';
			this.showTable = false;
			this.searchFlag = false;
			this.listRackinData = [];
			this.selectedmerchant = {}

			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	// this.merchantList = []

			// }
			// else if (this.user_type == 'client_user') {
			// 	this.warehouse = ''
			// }
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// 	// this.merchantList = []

			// }
		},
		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/putawayPending/putawayPending.component.js